export const NOTIFICATIONS_ROUTES = Object.freeze({
	NOTIFICATIONS_VIEW: '/notifications',
});
